import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ElementNext.messages';

import { 
  GlobalPrivateState, 
  navigationConfigurationData, 
  NavigationConfigurationItem,
  NavigationConfigurationKeys,
  NavigationConfigurationModel, 
} from 'src/api';

import './ElementNext.scss';

export interface ElementNextProps {
  id: NavigationConfigurationKeys;
  configuration: GlobalPrivateState['configuration'];
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ElementNextPartial extends React.Component<ElementNextProps> {
  public render() {
    return (
      <div className="partial-element-next">
        {this.link && (
          <Link
            className={classNames(
              'btn', 
              'btn-secondary', {
                'disabled': this.link.disabled,
              }
            )}
            onClick={(ev) => this.handleClick(ev, this.link !== undefined ? this.link.disabled : false)}
            to={this.link.to}
            title={this.link.title}
          >
            <FormattedMessage {...MESSAGES.elementNextbutton} />
          </Link>
        )}
      </div>
    );
  }

  private handleClick(event: React.MouseEvent<HTMLAnchorElement>, disabled: boolean) {
    if (disabled) {
      event.preventDefault();
    }
  }
  
  private get link(): NavigationConfigurationItem | undefined {
    if (!this.navigation) {
      return;
    }

    const {
      id,
      validated,
    } = this.props;
    
    const keys = Object.keys(this.navigation);
    const index = keys.indexOf(id);
    if (index === -1) {
      return;
    }

    const keyOfNext = keys[index + 1];
    if (!keyOfNext) {
      return;
    }

    const link = this.navigation[keyOfNext];
    if (!link) {
      return;
    }
    
    link.disabled = !validated.byPart[id];
    return link;
  }
  
  private get navigation(): NavigationConfigurationModel | undefined {
    const {
      configuration
    } = this.props;
    const conf = configuration.result;
    if (!conf) { return; }  
    return navigationConfigurationData(conf.id);
  }
}

export const ElementNext = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  validated: state.validatedConfiguration,
}))(ElementNextPartial);

export default ElementNext;
